export const useUserStore = defineStore('userStore', {
  state: () => ({
    user: {},
    friendToken: '',
    broadcastMessageId: '',
    gameInstanceId: '',
    joinSource: undefined,
    token: '',
    loading: false,
    groupId: '',
    remainingRevives: 4,
    telegramParams: {},
    isConnectToChildCalled: false,
    isIntroHide: true,
    isShowIntro: false,
    navbarTab: '',
    isFullScreen: false,
    isShowIdleReward: true,
    isNewLeaderBoardPrize: false,
    isFriendNotification: false,
    isVisitShop: false,
    isGameStart: false,
    playdeck: false,
    firstVisit: false,
    visitProfile: false,
    hasPlayedFirstGame: false,
    isNew: false,
    hasFirstGameOver: false,
    isCampaign: false,
    campaignData: null,
    isLoginToTheCampaign: false,
    isSuccessTransaction: false,
    isSetScore: false,
    powerUpCost: null,
    setCampaignHighScore: null,
    isCampaignTransaction: false,
  }),

  actions: {
    async profile() {
      const api = useApi()
      const response = await api.profile()
      this.user = response
    },

    setTgWebAppStartParam() {
      const urlParams = new URLSearchParams(window.location.search)
      const getTgWebAppStartParam = urlParams.get('tgWebAppStartParam')

      if (getTgWebAppStartParam) {
        const tgWebAppStartParam = getTgWebAppStartParam.split('__')
        const keys = () => {
          let key = []
          for (let i in tgWebAppStartParam) {
            key.push(tgWebAppStartParam[i].split('_')[0])
          }
          return key
        }

        const values = () => {
          let value = []
          for (let i in tgWebAppStartParam) {
            value.push(tgWebAppStartParam[i].split('_')[1])
          }
          return value
        }

        keys().forEach((key, index) => {
          this.telegramParams[key] = values()[index]
        })

        this.friendToken = this.telegramParams.ref
        this.broadcastMessageId = this.telegramParams.bmid
        this.joinSource = this.telegramParams.jso
      }
    },

    async updateUserInfo() {
      await this.getUser()
    },

    changeNavbarTab(tab) {
      this.navbarTab = tab
    },
  },
})
